import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "ngx-status-importacao",
  templateUrl: "./status.component.html",
  styleUrls: ["./status.component.scss"],
})
export class StatusComponent implements OnInit {
  @Input("fileName") fileName: string;
  @Input("total") total: number;
  @Input("imported") imported: number;
  @Input("status") status: "success" | "processing" | "error";
  @Input("buttonTitle") buttonTitle?: string;
  @Input("buttonType") buttonType: "cancel" | "simple" = "simple";
  @Output() showComponent: EventEmitter<boolean> = new EventEmitter();
  @Output() navigate: EventEmitter<boolean> = new EventEmitter();

  customLogin = null;
  showClose: boolean = false;

  ngOnInit(): void {
    const resCustom = localStorage.getItem("bway-customLogin");
    this.customLogin = JSON.parse(resCustom);
  }

  close() {
    this.showComponent.emit(false);
  }

  toNavigate() {
    this.navigate.emit();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getIcon() {
    switch (this.status) {
      case "success":
        return "checkmark-circle-2-outline";
      case "processing":
        return "sync-outline";
      case "error":
        return "alert-circle-outline";
    }
  }

  getMessage() {
    switch (this.status) {
      case "success":
        return "Processamento finalizado";
      case "processing":
        return "Processando planilha";
      case "error":
        return "Erro no processamento";
    }
  }

  getDescription() {
    switch (this.status) {
      case "success":
        return "Clique no botão '" + this.buttonTitle + "' para finalizar sua importação.";
      case "processing":
        return "Confira o status da sua importação aqui. Esse processo pode levar alguns minutos, mas você pode sair desta página e continuar utilizando a plataforma normalmente.";
      case "error":
        return "Não foi possivel completar a importação da planilha. Repita o processo de cadastro.";
    }
  }

  getIconStatus() {
    switch (this.status) {
      case "success":
        return "success";
      case "processing":
        return "warning";
      case "error":
        return "danger";
    }
  }
}
